import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import { initAnalytics } from './shared/analytics';

initAnalytics();

const rootElement = document.getElementById('root') as HTMLElement;
const app = (
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// Prerendered marketing routes (/solutions, /help) ship real HTML inside
// #root — hydrate it instead of re-rendering from scratch (RLX-FEAT-009).
// Every other route starts from an empty root and takes the classic path.
if (rootElement.hasChildNodes()) {
  ReactDOM.hydrateRoot(rootElement, app);
} else {
  ReactDOM.createRoot(rootElement).render(app);
}
